import { render, staticRenderFns } from "./OffCanvasDetailsSopimus.vue?vue&type=template&id=1e8555bb&scoped=true&"
import script from "./OffCanvasDetailsSopimus.vue?vue&type=script&lang=js&"
export * from "./OffCanvasDetailsSopimus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e8555bb",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e8555bb')) {
      api.createRecord('1e8555bb', component.options)
    } else {
      api.reload('1e8555bb', component.options)
    }
    module.hot.accept("./OffCanvasDetailsSopimus.vue?vue&type=template&id=1e8555bb&scoped=true&", function () {
      api.rerender('1e8555bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OffCanvasDetailsSopimus.vue"
export default component.exports